import Vue from 'vue'
import Modal from '@/components/Modal'
export default function(context) {
  const ModalConstructor = Vue.extend(Modal)
  const modal = new ModalConstructor().$mount()
  const instanceEl = modal.$el
  return function(params) {
    if (!document.body.contains(instanceEl)) {
      document.body.appendChild(instanceEl)
    }
    return modal.show(params)
  }
}
